import User from '@/models/User'

export default function useInitialPage(): Page {
    const el = document.querySelector('script[data-page="app"]')

    const content = el?.textContent || el?.innerHTML

    //@ts-ignore
    return JSON.parse(content)
}


interface SharedPageProps {
    flash?: {
        message: string
    }
    auth?: {
        user: User | null
    }
    url: {
        current: string
        intended?: string
    }
    csrf_token?: string
    breadcrumbs?: any
}

interface Page {
    component: string
    props: SharedPageProps
    url: string
    version: number
}
